export const CLIENTS_URLS = {
  CREATE_CLIENT: 'clients',
  GET_CLIENT_LOGGED_IN: 'clients/profile',
  GET_USER_CLIENTS: 'clients/GetClients',
  INVITE_MEMBERS: 'users/inviteMultipleUsers',
  GET_CLIENT_ACTIVE_USERS: 'clients/usersCount',
};
